module.exports = __webpack_public_path__ + "img/shouru.aa67af88.png";